import React from 'react';
export function ProductIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.005 6.939a1 1 0 00-1-.93h-2.5v-.5A3.5 3.5 0 0012.015 2h-.005a3.5 3.5 0 00-3.5 3.5V6h-2.5a1 1 0 00-1 .927l-.943 12.919a2 2 0 001.992 2.145l11.852.018a2 2 0 001.995-2.14l-.901-12.93zM10.51 5.5a1.5 1.5 0 011.5-1.5 1.5 1.5 0 011.5 1.5V6h-3v-.5zM6.062 19.991l.875-12L8.506 8v1a1 1 0 002 0V8h3v1a1 1 0 102 0V8h1.569l.84 12-11.853-.009z"
  }));
}